module.exports = __webpack_public_path__ + "static/media/dad-jokes-app.cc4bb0e1.JPG";